module.exports = __webpack_public_path__ + "img/NO937885822.79c827d3.png";